import { handleAction } from '@mendeley-internal/lib-js-redux-actions';
import { setConfig } from '../actions/config';

const initialState = {
  facebookId: null,
  environment: null
};

export default handleAction(setConfig, (state, { payload }) => payload, initialState);



// WEBPACK FOOTER //
// ./src/universal/ui/reducers/config.js